module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.ministeriofiel.fieldigital",
  "PUBLIC_API_DOMAIN_NAME": "api.fieldigital.com.br",
  "PUBLIC_API_DOMAIN_NAME_WEB": "",
  "PUBLIC_API_ENDPOINT": "",
  "PUBLIC_APPLE_ID": "6741170821",
  "PUBLIC_APP_ID": "325",
  "PUBLIC_APP_NAME": "Ministério Fiel Digital",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://fieldigital.com.br",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "c517b4d6-52e2-4133-a823-6af5e07831c8",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "fieldigital.com.br",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_ministerio",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6ODI5MDA2MTQyNzMzOndlYjpmNWMwMWM2ZTE1ZDA5NzdkYTkyNDQ0IiwiYXBpS2V5IjoiQUl6YVN5QlJ2NUpJOUN4ZWtKX05pd2t5Z1hYdE55REpiTUJTUUE4IiwicHJvamVjdElkIjoibWluaXN0ZXJpby1maWVsLWRpZ2l0YWwiLCJhdXRoRG9tYWluIjoibWluaXN0ZXJpby1maWVsLWRpZ2l0YWwuZmlyZWJhc2VhcHAuY29tIiwibWVhc3VyZW1lbnRJZCI6IkctTVNTNDBWTktRNSIsInN0b3JhZ2VCdWNrZXQiOiJtaW5pc3RlcmlvLWZpZWwtZGlnaXRhbC5maXJlYmFzZXN0b3JhZ2UuYXBwIiwibWVzc2FnaW5nU2VuZGVySWQiOiI4MjkwMDYxNDI3MzMifQ==",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BItK1zAT3IGMW-qzztVpgzRHIuev8FXDcfV7vXz5xmcdFD9da9jZiLtOh0L6PaGE0OqDERq4V_dTS7wI-wsuELE",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "oGiPNbybqupCp_DESQsuLUYkoDBYiZzb5MbsF6ztGNg",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#63c98f",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "45",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/4a4a3e5e-a44d-4855-8ec6-d6143c6f3282/uploads/41a314eb-47f1-4c3d-a07c-e55aa8e052ba.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.ministeriofiel.fieldigital",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "661620852573266",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PASSWORDLESS": "disabled",
  "PUBLIC_PAYMENT_FREEDOM_GRANTED_WEB": "true",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2mxMYwLVA3H46rhZvZZWnwamZrB",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "",
  "PUBLIC_SPLASH_LOGO_URL": "",
  "PUBLIC_SPLASH_LOGO_WIDTH": "",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#ffffff",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/4a4a3e5e-a44d-4855-8ec6-d6143c6f3282/uploads/4a001fbf-ce94-496c-a676-d10e72dd763e.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "135",
  "PUBLIC_TENANT_ID": "4a4a3e5e-a44d-4855-8ec6-d6143c6f3282",
  "PUBLIC_MAJOR_VERSION": "33",
  "PUBLIC_MINOR_VERSION": "5",
  "PUBLIC_PATCH_VERSION": "1",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "fieldigital.com.br@33.5.1",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "light"
}
